// extracted by mini-css-extract-plugin
module.exports = {"information":"LearningModuleOverviewInformation_information__1NWLk"};